"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { hasGermanTranslation } from "@/lib/i18n";
import styles from "./LanguageSwitcher.module.css";

/** Link to the same topic only when the translation actually exists. */
export default function LanguageSwitcher() {
  const pathname = usePathname() || "/";
  const german = pathname === "/de" || pathname.startsWith("/de/");
  let href: string;
  if (german) {
    const original = pathname.slice(3);
    href = original === "/suche" ? "/search"
      : original && hasGermanTranslation(original) ? original : "/";
  } else {
    href = pathname === "/search" ? "/de/suche"
      : hasGermanTranslation(pathname) ? `/de${pathname}` : "/de";
  }

  return (
    <Link
      className={styles.switch}
      href={href}
      hrefLang={german ? "en" : "de"}
      aria-label={german ? "Switch to English" : "Zur deutschen Dokumentation wechseln"}
      title={german ? "English" : "Deutsch"}
    >
      {german ? "EN" : "DE"}
    </Link>
  );
}
